<template>
  <base-page-learning-unit-info :editable="editable" mode="reviewer"></base-page-learning-unit-info>
</template>

<script>
import BasePageLearningUnitInfo from '../LearningUnitInfo/BasePageLearningUnitInfo';
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';

export default {
  components: {
    BasePageLearningUnitInfo
  },
  mixins: [learningUnitInfoMixin],

  computed: {
    editable() {
      const isPublish = this.learningUnit?.is_published;
      const isRequiredReview = this.learningUnit?.required_review;
      const isReviewer = this.$currentUser.isReviewer();

      // can only edit 'generalInfo' when is published and not required review
      // can only edit 'method' and 'learning' when is draft and not required review
      return {
        generalInfo: isReviewer && !isRequiredReview,
        method: isReviewer && !isPublish && !isRequiredReview,
        learning: isReviewer && !isPublish && !isRequiredReview
      };
    }
  }
};
</script>
